export enum IMAGE_VIEW_TYPE {
  EDITORIAL_LANDSCAPE = 'editorial_landscape',
  EDITORIAL_PORTRAIT = 'editorial_portrait',
  EDITORIAL_PORTRAIT_KIJK = 'editorial_portrait_kijk'
}
